import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TodayHot from "./components/TodayHot";
import WeekRank from "./components/WeekRank";
import Features from "./components/Features";
import Columns from "./components/Columns";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <TodayHot />
        <WeekRank />
        <Features />
        <Columns />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </div>
  );
}